import React from "react";
import omit from "@/utils/omit";
import { IconProps } from "../interface";

const IconSecure = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <svg
    ref={ref}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="yfm-icon yfm-icon-secure"
    {...omit(props, ["className"])}
  >
    <path
      d="M10 0L1.42859 2.85714V11.4286C1.42859 13.7019 2.33165 15.882 3.9391 17.4895C5.54656 19.0969 7.72673 20 10 20C12.2733 20 14.4535 19.0969 16.0609 17.4895C17.6684 15.882 18.5714 13.7019 18.5714 11.4286V2.85714L10 0ZM14.8762 8.25714L9.89526 13.2476C9.75242 13.3901 9.55891 13.4701 9.35716 13.4701C9.15541 13.4701 8.9619 13.3901 8.81907 13.2476L5.96192 10.3905C5.8825 10.3211 5.81753 10.2367 5.77073 10.1422C5.72392 10.0476 5.69618 9.94483 5.68911 9.83959C5.67482 9.62705 5.74555 9.41754 5.88573 9.25714C6.02592 9.09675 6.22408 8.99862 6.43662 8.98433C6.64916 8.97004 6.85867 9.04077 7.01907 9.18095L9.3524 11.5143L13.7429 7.12381C13.8857 6.98132 14.0792 6.9013 14.281 6.9013C14.4827 6.9013 14.6762 6.98132 14.8191 7.12381L14.8857 7.19048C15.0241 7.33414 15.1006 7.52632 15.0988 7.72575C15.097 7.92519 15.0171 8.11597 14.8762 8.25714Z"
      fill="white"
    />
  </svg>
));

IconSecure.displayName = "IconSecure";

export default IconSecure;
